var React = require('react');

function PauseRoundIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",{"type":"text/css"},".stf{fill-rule:evenodd;clip-rule:evenodd;}")),React.createElement("g",{"key":1},React.createElement("path",{"className":"stf sample-button","d":"M61.44,0c33.93,0,61.44,27.51,61.44,61.44c0,33.93-27.51,61.44-61.44,61.44S0,95.37,0,61.44 C0,27.51,27.51,0,61.44,0L61.44,0z M68.16,33.88H84.1V89l-15.94,0V33.88L68.16,33.88L68.16,33.88z M38.78,33.88h15.94V89l-15.94,0 V33.88L38.78,33.88L38.78,33.88z","style":{}}))]);
}

PauseRoundIcon.defaultProps = {"viewBox":"0 0 122.88 122.88","style":{"enableBackground":"new 0 0 122.88 122.88"}};

module.exports = PauseRoundIcon;

PauseRoundIcon.default = PauseRoundIcon;
